// Hidden fields must not retain values from another segment's form.
export const normaliseMiddleName = (data, enabled) => {
  // Preserve the empty state so FormBody can initialise every field from its model.
  if (data == null) return data;

  const { middleName, ...otherFields } = data;
  const trimmed = enabled === true ? middleName?.trim() : undefined;
  return trimmed ? { ...otherFields, middleName: trimmed } : otherFields;
};
